import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {graphql, Query} from 'react-apollo';


export const USER_QUERY = gql`
query getAuthenticatedUser {
  authenticatedUser {
    id
    firstName
    lastName
    email
    intercomVerificationToken
  }
}
`;

export const userShape = PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    intercomVerificationToken: PropTypes.string
});


export function withAuthenticatedUser(WrappedComponent) {
    class WithAuthenticatedUser extends React.Component {
        render() {
            const {loading, authenticatedUser} = this.props.data;

            return <WrappedComponent loadingUser={loading} authenticatedUser={authenticatedUser} {...this.props}/>;
        }
    }

    WithAuthenticatedUser.propTypes = {
        data: PropTypes.shape({
            loading: PropTypes.bool,
            authenticatedUser: userShape
        }),
        auth: PropTypes.shape({
            isLoggedIn: PropTypes.bool
        })
    };

    WithAuthenticatedUser.defaultProps = {
        data: {loading: false, authenticatedUser: {}}
    };


    return graphql(USER_QUERY)(WithAuthenticatedUser);
}

export class WithAuthenticatedUser extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired
    };

    render() {
        return (
            <Query query={USER_QUERY}>
                {({data, loading}) => this.props.children({user: data.authenticatedUser, loading})}
            </Query>
        );
    }
}
